import React from 'react';
import { Box, Text, TableCell, TableRow, Link } from '@razorpay/blade/components';
import { EmployeeTableNode } from '../types';
import { routePaths } from 'components/Routes/data';

export const EmployeeTableRow = ({ employee }: { employee: EmployeeTableNode }) => {
  return (
    <TableRow key={employee.id} item={employee} hoverActions={employee.rowHoverAction}>
      <TableCell>
        <Box display="flex" flexDirection="column">
          {employee.peopleId ? (
            <Link href={`${routePaths.employeeDetails.root}${employee.peopleId}`}>
              {employee.name}
            </Link>
          ) : (
            <Text weight="regular" color="surface.text.gray.normal">
              {employee.name}
            </Text>
          )}
          {!!employee.employeeId && (
            <Text size="small" color="surface.text.gray.muted">
              {employee.employeeId}
            </Text>
          )}
        </Box>
      </TableCell>

      <TableCell>
        <Text color="surface.text.gray.normal">{employee.designation}</Text>
      </TableCell>

      <TableCell>
        <Text color="surface.text.gray.normal">{employee.department}</Text>
      </TableCell>
    </TableRow>
  );
};
